export default __webpack_public_path__ + "static/img/vogue_scene_animated_0279.2a673e3.webp";